import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import httpHelper from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import { Method_TYPE } from 'utils/http-helper';
import Select from '../../../components/ui/Select';

const SamithiModal = ({ isModalOpen, setIsModalOpen, selectedPoint, getSamithiValue }) => {
    const [districts, setDistricts] = useState([]);

    useEffect(() => {
        getDistrictDetails();
    }, []);

    const getDistrictDetails = async () => {
        try {
            const response = await httpHelper(URL_CONSTANTS.GET_DISTRICT_LIST, Method_TYPE.GET);
            setDistricts(response?.data.map(district => ({
                value: district._id,
                label: district.districtName
            })));
        } catch (err) {
            console.error('Error fetching district details:', err);
            setDistricts([]);
        }
    };

    const [formData, setFormData] = useState({
        samithiName: '',
        district: ''
    });

    const [editId, setEditId] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (selectedPoint?.length > 0 && districts.length > 0) {
            const selectedDistrict = districts.find(
                district => district.value === selectedPoint[0]?.districtId
            );
            setFormData({
                samithiName: selectedPoint[0]?.samithi || '',
                district: selectedDistrict?.value || ''
            });
            setEditId(selectedPoint[0]?.samithiId);
        }
    }, [selectedPoint, districts]);

    const handleCancel = () => {
        setIsModalOpen(false);
        setFormData({ samithiName: '', district: '' });
        setEditId('');
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            if (selectedPoint?.length > 0) {
                await httpHelper(`${URL_CONSTANTS.EDIT_SAMATHI}/${editId}`, Method_TYPE.PUT, formData);
            } else {
                await httpHelper(URL_CONSTANTS.ADD_SAMATHI, Method_TYPE.POST, formData);
            }
            handleCancel();
            getSamithiValue()
        } catch (error) {
            console.error('Error saving Sector:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-card rounded-lg border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="flex items-center justify-between p-6 border-b border-border">
                    <div>
                        <h2 className="font-heading font-semibold text-lg text-foreground">
                            {selectedPoint?.length > 0 ? 'Edit Samithi' : 'Add Samithi'}
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            Configure Samithi requirements and details
                        </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={handleCancel} iconName="X" />
                </div>
                <form onSubmit={handleSubmit} className="p-6 space-y-6">
                    <div className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Input
                                label="Samithi"
                                name="samithiName"
                                type="text"
                                value={formData.samithiName}
                                onChange={(e) => handleInputChange('samithiName', e.target.value)}
                                required
                                placeholder="Enter Samithi Name"
                            />
                            <Select
                                label="District"
                                options={districts}
                                name="district"
                                value={formData.district}
                                onChange={(value) => handleInputChange('district', value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
                        <Button type="button" variant="outline" onClick={handleCancel} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="default"
                            loading={isLoading}
                            iconName="Save"
                            iconPosition="left"
                        >
                            {selectedPoint?.length > 0 ? 'Update Samithi' : 'Create Samithi'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SamithiModal;
